import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        this.refresh();
    }
    toggleAll() {
        const checked = this.selectAllTarget.checked;
        this.checkboxTargets.forEach((cb) => {
            cb.checked = checked;
        });
    }
    refresh() {
        const total = this.checkboxTargets.length;
        const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
        if (checkedCount === total) {
            this.selectAllTarget.checked = true;
            this.selectAllTarget.indeterminate = false;
        }
        else if (checkedCount === 0) {
            this.selectAllTarget.checked = false;
            this.selectAllTarget.indeterminate = false;
        }
        else {
            this.selectAllTarget.checked = false;
            this.selectAllTarget.indeterminate = true;
        }
    }
}
default_1.targets = ["selectAll", "checkbox"];
export default default_1;
